import { FC, useState, useEffect, createContext, useContext, useRef, Dispatch, SetStateAction } from "react";
import { LayoutSplashScreen } from "../../../../_private/layout/core";
import { AuthModel, UserModel } from "./_models";
import * as authHelper from "./AuthHelpers";
import { WithChildren } from "../../../../_private/helpers";
//import { TOKEN } from "../../../../redux/types";
import { useSelector } from "react-redux";
import { AppState } from "../../../../redux/types";

type AuthContextProps = {
	auth: AuthModel | undefined;
	saveAuth: (auth: AuthModel | undefined) => void;
	currentUser: UserModel | undefined;
	setCurrentUser: Dispatch<SetStateAction<any | undefined>>;
	logout: () => void;
};

const initAuthContextPropsState = {
	auth: authHelper.getAuth(),
	saveAuth: () => {},
	currentUser: undefined,
	setCurrentUser: () => {},
	logout: () => {},
};

const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState);

const useAuth = () => {
	return useContext(AuthContext);
};

const AuthProvider: FC<WithChildren> = ({ children }) => {
	
	const [auth, setAuth] = useState<AuthModel | undefined>(authHelper.getAuth());
	const [currentUser, setCurrentUser] = useState<any>();
	const saveAuth = (auth: AuthModel | undefined) => {
		setAuth(auth);
		if (auth) {
			authHelper.setAuth(auth);
		} else {
			authHelper.removeAuth();
		}
	};

	const logout = () => {
		saveAuth(undefined);
		setCurrentUser(undefined);
	};

	return <AuthContext.Provider value={{ auth, saveAuth, currentUser, setCurrentUser, logout }}>{children}</AuthContext.Provider>;
};

const AuthInit: FC<WithChildren> = ({ children }) => {
	const token = useSelector((state: AppState) => state.token);
	const { auth, logout, setCurrentUser } = useAuth();
	const didRequest = useRef(false);
	const [showSplashScreen, setShowSplashScreen] = useState(true);
	// We should request user by authToken (IN OUR EXAMPLE IT'S API_TOKEN) before rendering the application
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => {
		const requestUser = async (apiToken: string) => {
			if (!didRequest.current) {
				const data = token;
				if (data) {
					setCurrentUser(data);
				}
			}
			setShowSplashScreen(false);

			return () => (didRequest.current = true);
		};

		if (auth && token) {
			requestUser(token);
		} else {
			logout();
			setShowSplashScreen(false);
		}
		// eslint-disable-next-line
	}, []);

	return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>;
};

export { AuthProvider, AuthInit, useAuth };
